// extracted by mini-css-extract-plugin
export default {"error":"components-Shared-Form-renderWrapperError-themes-BGH-RD3-styles__error--UtKz9"};